import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronDown18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.46967 7.53033L4.53033 6.46967L9 10.9393L13.4697 6.46967L14.5303 7.53033L9 13.0607L3.46967 7.53033Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronDown18.displayName = 'ChevronDown18';
export default ChevronDown18;
